export default __webpack_public_path__ + "static/Live-Video_MJPEG-4d5f7abb3d069d2ab6dea81182037df1.webp";